<template>
  <div class="container-fluid">
    <div v-if="isSystemSettingIndex" class="mb-3">
      <h5 class="mb-0 font-weight-bold">System Setting</h5>
      <p class="text-secondary text-sm mb-0">
        Configure system-wide options. Select a sub-menu from the sidebar.
      </p>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "system-setting",
  computed: {
    isSystemSettingIndex() {
      const path = (this.$route.path || "").replace(/\/$/, "");
      return path === "/system-setting";
    },
  },
};
</script>
